(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mto-catalog-intro"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const mobileDirectory = window.matchMedia('(max-width: 768px)');

    const setCardState = (card, expanded) => {
      const button = card.querySelector('[data-mto-directory-toggle]');
      const panel = card.querySelector('[data-mto-directory-panel]');
      const label = card.querySelector('[data-mto-directory-toggle-label]');

      if (!button || !panel || !label) return;

      button.setAttribute('aria-expanded', String(expanded));
      panel.hidden = !expanded;
      label.textContent = `${expanded ? button.dataset.collapseLabel : button.dataset.expandLabel}: ${card.querySelector('h3').textContent.trim()}`;
    };

    const syncDirectory = (directory) => {
      directory.querySelectorAll('[data-mto-directory-card]').forEach((card) => {
        setCardState(card, !mobileDirectory.matches);
      });
    };

    const initializeDirectory = (directory) => {
      if (directory.dataset.mtoDirectoryReady === 'true') return;

      directory.dataset.mtoDirectoryReady = 'true';
      directory.querySelectorAll('[data-mto-directory-toggle]').forEach((button) => {
        button.addEventListener('click', () => {
          const card = button.closest('[data-mto-directory-card]');
          const willExpand = button.getAttribute('aria-expanded') !== 'true';

          if (willExpand) {
            directory.querySelectorAll('[data-mto-directory-card]').forEach((otherCard) => {
              setCardState(otherCard, false);
            });
          }

          setCardState(card, willExpand);
        });
      });

      syncDirectory(directory);
    };

    const initializeAllDirectories = (root = document) => {
      root.querySelectorAll('.mto-directory').forEach(initializeDirectory);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeAllDirectories, { once: true });
    } else {
      initializeAllDirectories();
    }
    mobileDirectory.addEventListener('change', () => {
      document.querySelectorAll('.mto-directory').forEach(syncDirectory);
    });
    document.addEventListener('shopify:section:load', (event) => {
      initializeAllDirectories(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mto-product-request"]) return;
  try {
    
  document.querySelectorAll('[data-mto-request]').forEach(function (section) {
    var form = section.querySelector('form');
    var successPanel = section.querySelector('[data-mto-success]');
    var emailButton = section.querySelector('[data-mto-email-submit]');
    var whatsappButton = section.querySelector('[data-mto-whatsapp]');
    var emailInput = section.querySelector('[data-mto-email]');
    var channelInput = section.querySelector('[data-mto-channel]');
    var sharedValidation = section.querySelector('[data-mto-validation]');
    var emailValidation = section.querySelector('[data-mto-email-validation]');

    if (successPanel) {
      successPanel.focus();
      return;
    }

    if (!form || !emailButton || !emailInput || !channelInput) return;

    function clearValidation() {
      sharedValidation.hidden = true;
      emailValidation.hidden = true;
    }

    function value(selector) {
      var field = section.querySelector(selector);
      return field ? field.value.trim() : '';
    }

    function label(selector) {
      var field = section.querySelector(selector);
      return field && field.labels.length ? field.labels[0].textContent.trim() : '';
    }

    emailButton.addEventListener('click', function () {
      clearValidation();
      channelInput.value = 'Email';
      emailInput.required = true;
      if (!emailInput.value.trim()) emailValidation.hidden = false;
    });

    form.addEventListener('submit', function (event) {
      clearValidation();
      channelInput.value = 'Email';
      emailInput.required = true;
      if (!emailInput.value.trim()) {
        event.preventDefault();
        emailValidation.hidden = false;
        form.reportValidity();
      }
    });

    if (!whatsappButton) return;

    whatsappButton.addEventListener('click', function () {
      clearValidation();
      channelInput.value = 'WhatsApp';
      emailInput.required = false;

      if (!form.reportValidity()) {
        sharedValidation.hidden = false;
        return;
      }

      var country = value('[data-mto-country]');
      var region = value('[data-mto-region]');
      var delivery = [country, region].filter(Boolean).join(', ');
      var metalField = section.querySelector('[data-mto-metal]');
      var metal = metalField ? metalField.options[metalField.selectedIndex].text : '';
      var labels = [
        label('[data-mto-name]'),
        label('[data-mto-email]'),
        label('[data-mto-phone]'),
        label('[data-mto-country]'),
        label('[data-mto-size]'),
        label('[data-mto-metal]'),
        label('[data-mto-notes]')
      ];
      var lines = [
        section.dataset.messageTitle,
        '',
        value('[data-mto-product-title]'),
        value('[data-mto-product-url]'),
        '',
        labels[0] + ': ' + value('[data-mto-name]')
      ];

      var email = value('[data-mto-email]');
      var phone = value('[data-mto-phone]');
      var size = value('[data-mto-size]');
      var notes = value('[data-mto-notes]');

      if (email) lines.push(labels[1] + ': ' + email);
      if (phone) lines.push(labels[2] + ': ' + phone);
      lines.push(labels[3] + ': ' + delivery);
      if (size) lines.push(labels[4] + ': ' + size);
      lines.push(labels[5] + ': ' + metal);
      if (notes) lines.push(labels[6] + ': ' + notes);

      window.location.assign(
        'https://wa.me/' + section.dataset.whatsappNumber + '?text=' + encodeURIComponent(lines.join('\n'))
      );
    });
  });

  } catch(e) { console.error(e); }
})();
})();
